

export enum TriggerEventType {
	TemplateAssociation = 0,
	WorkflowAction = 1,
	DataBehavior = 2,
	RecordCreation = 3
}